import { Link } from "react-router-dom";
import { Phone, Mail, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy text-white/80 mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <span className="text-2xl font-heading font-extrabold text-white">
            Morning<span className="text-orange">Box</span>
          </span>
          <p className="mt-3 text-sm text-white/60">La colazione perfetta, dove vuoi tu.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Servizio</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/come-funziona" className="hover:text-orange transition-colors">Come funziona</Link></li>
            <li><Link to="/pacchetti" className="hover:text-orange transition-colors">Pacchetti</Link></li>
            <li><Link to="/per-bnb" className="hover:text-orange transition-colors">Per i B&B</Link></li>
            <li><Link to="/per-bar" className="hover:text-orange transition-colors">Per bar e pasticcerie</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legale</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/privacy" className="hover:text-orange transition-colors">Privacy Policy</Link></li>
            <li><Link to="/legal/cookie" className="hover:text-orange transition-colors">Cookie Policy</Link></li>
            <li><Link to="/legal/termini" className="hover:text-orange transition-colors">Termini e condizioni</Link></li>
            <li><Link to="/legal/condizioni-bnb" className="hover:text-orange transition-colors">Condizioni B&B</Link></li>
            <li><Link to="/legal/condizioni-bar" className="hover:text-orange transition-colors">Condizioni bar</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contatti</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-orange" /> 338 275 7380</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-orange" /> info@morningbox.it</li>
            <li className="flex items-center gap-2"><Globe className="w-4 h-4 text-orange" /> www.morningbox.it</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} MorningBox · Zona iniziale: Agro Nocerino-Sarnese
      </div>
    </footer>
  );
}
